(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["addresses"]) return;
  try {
    
  Shopify.postLink = function (path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    for (var key in params) {
      var hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);
      form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  const addNewButton = document.querySelector('#add-new-address');
  const addNewForm = document.querySelector('#AddAddress');
  const existingAddresses = document.querySelector('#existing-addresses');
  const addressPreviews = document.querySelectorAll('.address-preview');
  const cancelEditButtons = document.querySelectorAll('.cancel-edit-button');

  const deleteButtons = document.querySelectorAll('.delete-address-button');

  const attributes = {
    expanded: 'aria-expanded',
    confirmMessage: 'data-confirm-message',
  };

  deleteButtons?.forEach((button) => {
    button.addEventListener('click', (e) => {
      // console.log(Shopify);
      if (confirm(e.target.getAttribute('data-confirm-message'))) {
        Shopify.postLink(e.target.dataset.target, {
          parameters: { _method: 'delete' },
        });
      }
    });
  });

  cancelEditButtons?.forEach((button) => {
    button.addEventListener('click', (e) => {
      location.reload();
    });
  });

  addNewButton?.addEventListener('click', (e) => {
    document.querySelector('#add-new-button-wrap')?.classList.toggle('hidden');
    addNewForm.classList.remove('hidden');
    existingAddresses.classList.add('hidden');
    addressPreviews.forEach((preview) => {
      preview.classList.add('hidden');
    });
  });

  const editFormButtons = document.querySelectorAll('[id^="EditFormButton_"]');

  editFormButtons.forEach((button) => {
    button.addEventListener('click', (e) => {
      const b = e.target;
      const addressId = b.getAttribute('data-address-id');
      const editAddress = document.querySelector(`#EditAddress_${addressId}`);

      editAddress?.classList.toggle('hidden');
      document.querySelector('#add-new-button-wrap')?.classList.toggle('hidden');
      addressPreviews.forEach((preview) => {
        // console.log(preview);
        preview.classList.add('hidden');
      });
    });
  });

  // editFormButtons?.[0]?.click();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["create-account-banner"] && !Shopify.designMode) return;
  try {
    
  const el = document.querySelector('#newsletter-modal-trigger');
  const newsletterModal = document.querySelector('.newsletter-modal');

  el?.addEventListener('click', (e) => {
    e.preventDefault();
    newsletterModal.classList.remove('hidden');
    document.body.classList.add('overflow-hidden');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["login-form"]) return;
  try {
    

  document.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash;

    const recoverPasswordButton = document.getElementById('recover-password-button');
    const magicLinkForm = document.getElementById('send-magic-link');
    const magicLinkFormButtonWrap = document.getElementById('magic-link-form-button-wrap');
    const magicLinkFormInput = document.getElementById('magic-link-form-input');

    magicLinkForm.addEventListener('submit', async (event) => {
      event.preventDefault();

      document.getElementById('magic-link-form-success').classList.add('hidden');
      document.getElementById('magic-link-form-error').classList.add('hidden');
      magicLinkFormInput.classList.remove('hidden');
      magicLinkFormButtonWrap.classList.remove('hidden');
      
      const url = 'https://cdn-app.sealsubscriptions.com/shopify/public/proxy/api/send-customer-portal-magic-link-v01.php';
      const formData = new FormData(event.target);
      
      const email = formData.get('customer_email');

      formData.set('send_email', 'customer_email=' + email);
      const response = await fetch(url, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        document.getElementById('magic-link-form-success').classList.remove('hidden');
        document.getElementById('magic-link-form-error').classList.add('hidden');
        magicLinkFormInput.classList.add('hidden');
        magicLinkFormButtonWrap.classList.add('hidden');
      } else {
        document.getElementById('magic-link-form-success').classList.add('hidden');
        document.getElementById('magic-link-form-error').classList.remove('hidden');
      }
    });

    if (recoverPasswordButton) {
      recoverPasswordButton.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('.login').classList.add('hidden');
        document.querySelector('.recover-email').classList.remove('hidden');
      });
    }

    if (hash === '#recover') {
      document.querySelector('.login').classList.add('hidden');
      document.querySelector('.recover-email').classList.remove('hidden');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    

document.addEventListener("DOMContentLoaded", function () {
  document.body.classList.add("overflow-hidden");
  document.querySelector('#cart-drawer').classList.add('open');
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-modal"]) return;
  try {
    
  const newsletterModal = document.querySelector('.newsletter-modal');
  const closeNewsletterModal = document.querySelector('#close-newsletter-modal');

  const closeModal = () => {
    newsletterModal.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  };

  closeNewsletterModal?.addEventListener('click', () => {
    closeModal();
  });

  newsletterModal?.addEventListener('click', (e) => {
    // console.log(e.target, newsletterModal, e.target == newsletterModal);
    if (e.target === newsletterModal) {
      closeModal();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const cartLink = document.getElementById('cart-link');
    const cartDrawer = document.querySelector('#cart-drawer');
    const cartDrawerWrap = document.querySelector('.cart-drawer-wrap');

    const menuLink = document.querySelector('#menu-link');

    const burger = document.getElementById('burger');
    const close = document.getElementById('close');
    const siteHeader = document.querySelector('.site-header');

    menuLink.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('.mobile-menu-outer').classList.toggle('hidden');
      burger.classList.toggle('hidden');
      close.classList.toggle('hidden');
      document.body.classList.toggle('menu-open');
      siteHeader.classList.toggle('menu-open');
      document.body.classList.toggle('overflow-hidden');
    });

    close.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('.mobile-menu-outer').classList.toggle('hidden');
      burger.classList.toggle('hidden');
      close.classList.toggle('hidden');
      document.body.classList.toggle('menu-open');
      siteHeader.classList.toggle('menu-open');
      document.body.classList.toggle('overflow-hidden');
    });

    cartLink.addEventListener('click', function (e) {
      e.preventDefault();
      cartDrawer.classList.toggle('open');
      document.body.classList.toggle('overflow-hidden');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    

  const players = document.querySelectorAll('.video-player');

  players?.forEach(player => {
    
    player.addEventListener('click', () => {
      
      const videoId = player.getAttribute('data-target');
      const video = document.getElementById(videoId);
      const button = player.querySelector(`.video-play-button`);
      const overlay = player.querySelector(`.video-player-overlay`);

      if (video.paused) {
        video.play();
        player.classList.add('playing');
        player.classList.remove('paused');
      } else {
        video.pause();
        player.classList.add('paused');
        player.classList.remove('playing');
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
